'use client'

import { type ButtonProps, MultiSelect } from '@repo/ui'

import type { ChainId } from '../web3.types'

import { getChainShortName } from '../utils/chain.utils'
import { ChainIcon } from './ChainIcon'

interface ChainMultiSelectProps {
  label: string
  options: ChainId[]
  values: ChainId[]
  setValues: (values: ChainId[]) => void
  triggerVariant?: ButtonProps['variant']
}

export function ChainMultiSelect({
  options,
  label,
  values,
  setValues,
  triggerVariant
}: ChainMultiSelectProps) {
  'use memo'

  return (
    <MultiSelect
      label={label}
      options={options.map(chainId => ({
        value: chainId.toString(),
        keywords: [getChainShortName(chainId) || '', chainId.toString()],
        component: (
          <div className="flex items-center gap-2">
            <ChainIcon chainId={chainId} />
            <span>{getChainShortName(chainId)}</span>
          </div>
        )
      }))}
      values={values.map(v => v.toString())}
      onChange={values => setValues(values.map(v => Number(v) as ChainId))}
      triggerVariant={triggerVariant}
    />
  )
}
